module.exports = __webpack_public_path__ + "img/three_txt2.80ffb6ea.png";